/** The gateway grants the hour as the recording starts; this covers the gap before the note's own start time. */
const GRANT_LEAD_MS = 10 * 60 * 1000

interface RecordedMeeting {
  startedAt?: Date | string | null
  endedAt?: Date | string | null
}

/**
 * Whether this finished recording is the one Free's one-time grace hour was
 * granted for: the hour is claimed when a meeting starts with Free's hours
 * spent, so it was granted as this recording started.
 */
export function ranOnFreeGraceHour(recording: RecordedMeeting | null, grantedAt: string | null | undefined): boolean {
  if (!recording?.startedAt || !recording.endedAt || !grantedAt) {
    return false
  }
  const granted = new Date(grantedAt).getTime()
  const started = new Date(recording.startedAt).getTime()
  const ended = new Date(recording.endedAt).getTime()
  return granted >= started - GRANT_LEAD_MS && granted <= ended
}
